/*
 * healthmart
 * version 2.2
 * http://www.healthmart.com
 *
 * Copyright (c) 2019 healthmart ltd
 * Author healthmart ltd <support@healthmart.com>
 * Licensed under the MIT license.
 */
import { Component, OnInit, Input, Output, forwardRef, ElementRef, EventEmitter, ViewChild } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import * as moment from 'moment';
import { DatePipe } from '@angular/common';
//Changed format of daee universally
// See the Moment.js docs for the meaning of these formats:
// https://momentjs.com/docs/#/displaying/format/
export const MY_FORMATS = {
    parse: {
        dateInput: 'LL',
    },
    display: {
        dateInput: 'DD/MMM/YYYY',
        monthYearLabel: 'MMM/YYYY',
        dateA11yLabel: 'LL',
        monthYearA11yLabel: 'MMM/YYYY',
    },
};

@Component({
    selector: 'app-custom-date',
    templateUrl: './custom-date.component.html',
    styleUrls: ['./custom-date.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => CustomDateComponent),
            multi: true
        },
        { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
        { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
    ],
    standalone: false
})


export class CustomDateComponent implements ControlValueAccessor {

    @Input() inputType: any;
    @Input() dataType: any = 1;
    @Input() currentValue: any;
    @Input() inputPlaceHolder: string;
    @Input() inputId: string;
    @Input() inputName: string;
    @Input() endDate: any;
    @Input() classAdd: any;
    @Input() startDate: any;
    @Input() inputWrapperClass: string;
    @Input() labelText: string;
    @Input() lableClass: string = 'label fs-5 text-1 fw-500';
    @Input() inputClass: string = 'form-control fs-6 my-3 ms-3 p-3 border-0 bg-7 br-05';
    @Input() icon: string;
    @Input() iconClass: string;
    @Input() iconWrapperClass: string = 'input-group-text border-0 bg-7 br-05 my-t-b-3';
    @Input() error: any;
    @Input() errorMessage: any;
    @Input() errorMessage_required: any;
    @Input() errorMessage_pattern: any;
    @Input() checked: boolean;
    @Input() additionInputClass: string;
    @Input() fcontrol: any;
    @Input() formSubmit: boolean = false;
    @Input() fvalue: any;
    @Input() maxDate: any;
    @Input() minDate: any;
    @Input() typefrom:any;

    dateName: any;
    @ViewChild('input') inputRef: ElementRef;

    @Output() emptyDecorator: EventEmitter<any> = new EventEmitter();
    @Output() TextChange: EventEmitter<any> = new EventEmitter<any>();
    @Output() updateValue: EventEmitter<any> = new EventEmitter<any>();

    touched = false;
    checkboxChecked = false;
    passwordFieldType = 'password';
    passwordEyeIcon = 'fas fa-eye';

    constructor( private datePipe: DatePipe,private dateAdapter: DateAdapter<any>) {
    }
    appLanguage
    ngOnInit(): void {
        const lang = localStorage.getItem('loginUserValue') &&
        JSON.parse(localStorage.getItem('loginUserValue'));
        this.appLanguage = lang?.languages?.locale || 'en';
        console.log( this.appLanguage," this.appLanguage")
        this.dateAdapter.setLocale(this.appLanguage);
        this.dateName = this.inputName;
        if (this.checked) {
            this.checkboxChecked = true
        }
        this.inputClass = this.inputClass + ' ' + this.additionInputClass;
        
    }

    onTouched: any = () => { };
    //The internal data model for form control value access
    innerValue: any = '';

    // event fired when input value is changed . later propagated up to the form control using the custom value accessor interface
    onChange(event: any) {
        this.innerValue = event.target.value;
        // this.defaultValue = event.target.value;
        // // propagate value into form control using control value accessor interface
        this.propagateChange(this.innerValue);
        // if (value == '') {
        //     this.updateValue.emit(this.defaultValue);
        // } else {
        // const dateToSave = event.target.value.toISOString().slice(0, 10);
        // console.log(dateToSave);
        if(this.typefrom == "Agenda"){
            const currentTime = moment().format('HH:mm:ss');
            const outputDate = moment(event.target.value).format().split("T")[0];   
            const dateWithTime = `${outputDate} ${currentTime}`;     
            this.updateValue.emit(dateWithTime);
        }
        else{
            const outputDate = moment(event.target.value).format().split("T")[0];        
        this.updateValue.emit(outputDate);
        }
        
        // }

    }

    // onChange(Event) {
    //     this.touched = true;
    //     //set changed value
    //     this.innerValue = Event.value;

    //     // propagate value into form control using control value accessor interface
    //     this.propagateChange(this.innerValue);
    //     this.keyup.emit(true);
    // }

    //get accessor
    get value(): any {
        return this.innerValue;
    };

    //set accessor including call the onchange callback
    set value(v: any) {
        if (v !== this.innerValue) {
            this.innerValue = v;
        }
    }

    //propagate changes into the custom form control
    propagateChange = (_: any) => { }

    //From ControlValueAccessor interface
    writeValue(value: any) {
        this.innerValue = value;
    }

    //From ControlValueAccessor interface
    registerOnChange(fn: any) {
        this.propagateChange = fn;
    }

    //From ControlValueAccessor interface
    registerOnTouched(fn: any) {
        this.onTouched = fn;
    }
}